<template>
    <TemplateGalleryHtmlCard
        show-header
        :selected="selected"
        :disabled="disabled"
        :template="template"
    >
        <template #preTitleContent>
            <DsChip class="legacy-chip">
                {{ $t('unlayerBuilder.templateSelection.tabs.bard.card.title') }}
            </DsChip>
        </template>

        <template #overlay>
            <DsFilledButton
                class="convert-button"
                data-qa="migrate-to-unlayer-button"
                @click="$emit('migrate-to-unlayer')"
            >
                {{ $t('unlayerBuilder.templateSelection.tabs.try.new.exp') }}
            </DsFilledButton>

            <div>
                <DsTextButton
                    leading-icon="eye-show"
                    data-qa="preview-bard-template-button"
                    @click="$emit('preview')"
                >
                    {{ $t('global.preview') }}
                </DsTextButton>

                <DsTextButton
                    leading-icon="trash-2"
                    data-qa="delete-bard-template-button"
                    destructive
                    @click="$emit('delete-template')"
                >
                    {{ $t('global.delete') }}
                </DsTextButton>
            </div>
        </template>
    </TemplateGalleryHtmlCard>
</template>

<script>
import TemplateGalleryHtmlCard from './TemplateGalleryHtmlCard';

export default {
    name: 'TemplateGalleryBardCard',

    components: {
        TemplateGalleryHtmlCard,
    },

    props: {
        template: {
            type: Object,
            required: true,
        },
        selected: Boolean,
        disabled: Boolean,
    },

    emits: ['preview', 'delete-template', 'migrate-to-unlayer'],
};
</script>

<style lang="scss" scoped>
.legacy-chip {
    margin-right: $spacing-100;
    --chip-background-color:#{$color-green};
    --chip-text-color: #{$color-paper};
    flex-shrink: 0;
}

.convert-button {
    margin-bottom: $spacing-100;
}
</style>
